var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNegatePres(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9C7942B0-E6C5-4D90-B7AD-FAE1BCBF1CB3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dise\\xF1o-enviar-presupuesto",
    transform: "translate(-625.000000, -676.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solicitudes-Copy",
    transform: "translate(596.250000, 665.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(29.250000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09912008,2.40086256 C7.89794686,2.19971248 7.57531056,2.19971248 7.37413734,2.40086256 L4.125,5.64962622 L0.875862664,2.40086256 C0.674689441,2.19971248 0.35205314,2.19971248 0.150879917,2.40086256 C-0.0502933057,2.60201265 -0.0502933057,2.92461185 0.150879917,3.12576193 L3.40001725,6.37452559 L0.150879917,9.62328925 C-0.0502933057,9.82443933 -0.0502933057,10.1470385 0.150879917,10.3481886 C0.249568668,10.446866 0.38241891,10.5 0.51147343,10.5 C0.64052795,10.5 0.773378192,10.4506613 0.872066943,10.3481886 L4.12120428,7.09942496 L7.37034161,10.3481886 C7.46903037,10.446866 7.60188061,10.5 7.73093513,10.5 C7.86378537,10.5 7.99283989,10.4506613 8.09152864,10.3481886 C8.29270186,10.1470385 8.29270186,9.82443933 8.09152864,9.62328925 L4.84998275,6.37452559 L8.09912008,3.12576193 C8.30029331,2.92461185 8.30029331,2.60201265 8.09912008,2.40086256 Z",
    id: "Path"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegatePres);
export default __webpack_public_path__ + "static/media/negate-pres.4de5d933.svg";
export { ForwardRef as ReactComponent };